import { createHash, randomBytes } from "react-native-quick-crypto";

export async function createSalt() {
  return randomBytes(16).toString("hex");
}

export async function hashPasscode(pin, salt) {
  return createHash("sha256").update(`${salt}:${pin}`).digest("hex");
}

export async function verifyPasscode(pin, salt, storedHash) {
  if (!pin || !salt || !storedHash) return false;
  const h = await hashPasscode(pin, salt);
  return h === storedHash;
}
